<div class="recent-tips-container">
  <h1>Recent Tips</h1>
  <div *ngFor="let tip of tips" class="tip-card">
    <p>{{ tip.field_user_text }}</p>
    <div class="tip-meta">
      <div class="tip-author">
        <span>{{ tip.created | formatTimestamp:'dd MMM yyyy HH:mm' }}</span>
        <span>by {{ tip.title }}</span>
      </div>
      <div class="tip-actions">
        <div class="tip-likes">
          <i class="fas fa-heart"></i>
          <span>{{ tip.field_tips_like_count }} likes</span>
        </div>
        <div class="tip-share">
          <i class="fas fa-share"></i>
          <span>Share</span>
        </div>
      </div>
    </div>
  </div>
</div>